module.exports = __webpack_public_path__ + "img/RCT03.ab2b3108.svg";